import { render, staticRenderFns } from "./sliderItem.vue?vue&type=template&id=a8845194&"
import script from "./sliderItem.vue?vue&type=script&lang=js&"
export * from "./sliderItem.vue?vue&type=script&lang=js&"
import style0 from "./sliderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports